<template>
  <el-dialog append-to-body width="1000px" :title="detail.name" :visible.sync="visible" :before-close="handleClose">
    <div class="modal-body">
      <div class="content" v-html="detail.content">
       
      </div>
      <div class="reservation-btn" @click="handleAgree">我已同意</div>
    </div>
  </el-dialog>
</template>

<script>
import waves from '@/directive/waves' // 水波纹指令
import { getPageDetail } from "@/api/page";
export default {
  name: 'Agreement',
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    alias: {
      type: String,
      default: 'register'
    },
  },
  data() {
    return {
      loading: false,
      detail: {},
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.getPageDetail()
      }
    }
  },
  methods: {
    getPageDetail() {
      getPageDetail({ alias: this.alias }).then(res => {
        this.loading = false;
        this.detail = res.data;
      }).catch((err) => {

      });
    },
    handleAgree() {
      this.$emit('agree', 1);
      this.handleClose()
    },
    // 关闭窗口
    handleClose() {
      // 更新visible参数
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 10px ;
  box-sizing: border-box;


  .content {   
    font-size: 14px;
    font-weight: 400;
    color: #343A40;
    line-height: 28px;
    width: 100%;
    padding: 10px 16px;
    box-sizing: border-box;
    background: #F4F8F9;
    max-height: 500px;
    overflow-y: scroll;
  }

  .reservation-btn {
    padding: 10px 50px;
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
    background: #00B4E8;
    border-radius: 25px;
    margin: 30px auto 0;
    width: fit-content;
    cursor: pointer;
  }
}
</style>
